import React from "react";
import { Row, Col } from "antd";
import SkeletonItem from "../Item/Skeleton";

const SkeletonResults = () => {
  const arraySkeleton = Array(6).fill(0);

  return (
    <Row
      className="beon-showcase--grid beon-showcase--default"
      gutter={[24, 12]}
    >
      {arraySkeleton.map((_, index) => (
        <Col md={8} xs={12} key={index}>
            <SkeletonItem />
        </Col>
      ))}
    </Row>
  );
};

export default SkeletonResults;
